// extracted by mini-css-extract-plugin
export default {"container":"X0-z","heading":"Y0-z","links":"Z0-z","copy":"_0-z","subCopy":"a1-z","linksLeft":"b1-z","linksCenter":"c1-z","linksRight":"d1-z","link":"e1-z","onlyLink":"f1-z"};